import React, {  useRef, useState } from "react";
import { ErrorIcon } from "../Svg";

const Cancel = () => {

  const [error,setError] = useState("")
  const [done,setDone] = useState(false)
  const hasMounted = useRef(false);


  

  
  return <div className="hero">
    <div className="form__container">
      <div className="successContainer">
       <>
         <h4>Ooops, Une Erreur Est Survenue</h4>
         <ErrorIcon />
         <span className="error"> Votre Paiement a été annulé</span> 
         
         </>
      
      </div>
    </div>
  </div>;
};

export default Cancel;
